import { tradingHouseAPI } from "./api";

export const getProviderRequests = async (params) => {
  try {
    const res = await tradingHouseAPI.getProviderRequests(params);
    return res?.data || [];
  } catch (e) {}
};

export const getProviderRequestDetail = async (params) => {
  try {
    const res = await tradingHouseAPI.getProviderRequestDetail(params);
    return res?.data || [];
  } catch (e) {}
};

export const getInvoiceItems = async (params) => {
  try {
    const res = await tradingHouseAPI.getInvoiceItems(params);
    return res?.data || [];
  } catch (e) {}
};

export const getRealizationItems = async (params) => {
  try {
    const res = await tradingHouseAPI.getRealizationItems(params);
    return res?.data || [];
  } catch (e) {}
};

export const tradingHouseRequestColumns = [
  {
    name: "provider_request_id",
    label: "ID материала",
    field: "provider_request_id",
    align: "center",
  },
  {
    name: "material_name",
    label: "Наименование материала",
    field: "material_name",
    align: "left",
  },
  {
    name: "date_shipping",
    label: "Дата отгрузки",
    field: "date_shipping",
    align: "center",
  },
  {
    name: "quantity",
    label: "Количество",
    field: "quantity",
    align: "center",
  },
  {
    name: "sell_unit_name",
    label: "Ед. изм.",
    field: "sell_unit_name",
    align: "center",
  },
  {
    name: "price",
    label: "Цена, тг",
    field: "price",
    align: "center",
  },
  {
    name: "amount",
    label: "Сумма, тг",
    field: "amount",
    align: "center",
  },
  {
    name: "shipped_cnt",
    label: "Отгруженное кол-во по накладным",
    field: "shipped_cnt",
    align: "center",
  },
];

export const getProviderRequestDetailColumns = [
  {
    name: "request_info",
    label: "Заявка",
    field: "request_info",
    align: "left",
  },
  {
    name: "provider_name",
    label: "Поставщик",
    field: "provider_name",
    align: "left",
  },
  {
    name: "contractor_name",
    label: "Подрядчик",
    field: "contractor_name",
    align: "left",
  },
  {
    name: "address_delivery",
    label: "Адрес доставки",
    field: "address_delivery",
    align: "left",
  },
  {
    name: "status",
    label: "Накладные",
    field: "status",
    align: "center",
  },
  {
    name: "status",
    label: "Реализация",
    field: "status",
    align: "center",
  },
  {
    name: "status",
    label: "Статус",
    field: "status",
    align: "left",
  },
  {
    name: "",
    label: "",
    field: "",
    align: "center",
  },
];

export const invoiceColumns = [
  {
    name: "invoice_num",
    label: "ID материала",
    field: "invoice_num",
    align: "center",
  },
  {
    name: "invoice_num",
    label: "Наименование материала",
    field: "invoice_num",
    align: "left",
  },
  {
    name: "invoice_num",
    label: "Кол-во",
    field: "invoice_num",
    align: "center",
  },
  {
    name: "sell_unit_name",
    label: "Ед. изм.",
    field: "sell_unit_name",
    align: "center",
  },
  {
    name: "invoice_num",
    label: "Цена, тг",
    field: "invoice_num",
    align: "center",
  },
  {
    name: "invoice_num",
    label: "Сумма, тг",
    field: "invoice_num",
    align: "center",
  },
];